import api from '.';
import { ActionPlanCategory, ActionPlanItem, Message } from '@karehero/models';

export const actionPlanApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllActionPlan: builder.query<ActionPlanItem[], void>({
      query: () => '/action-plan',
      providesTags: ['ActionPlan'],
    }),
    updateActionPlan: builder.mutation<void, ActionPlanItem>({
      query: (actionPlanItem) => ({
        url: `/action-plan`,
        method: 'PUT',
        body: actionPlanItem,
      }),
      invalidatesTags: ['ActionPlan', 'ActionPlanCategory'],
    }),
    getAllActionPlanCategoryForCareCircle: builder.query<
      ActionPlanCategory[],
      string
    >({
      query: (careCircleID) => ({
        url: `/action-plan/care-circle/${careCircleID}/category`,
      }),
      providesTags: ['ActionPlanCategory'],
    }),
    getAllActionPlanFeedback: builder.query<
      { actionPlanItemID: string; isFeedback: boolean }[],
      string
    >({
      query: (careCircleID) => ({
        url: `/action-plan/care-circle/${careCircleID}/feedback`,
      }),
      providesTags: ['ActionPlanFeedback'],
    }),
    markActionFeedback: builder.mutation<
      void,
      { actionID: string; careCircleID: string }
    >({
      query: ({ actionID, careCircleID }) => ({
        url: `/action-plan/care-circle/${careCircleID}/${actionID}/feedback`,
        method: 'POST',
      }),
      invalidatesTags: ['CareCircles', 'ActionPlanFeedback'],
    }),
    generateActionPlan: builder.mutation<Message, void>({
      query: () => ({
        url: `/action-plan/generate`,
        method: 'POST',
      }),
      invalidatesTags: ['ActionPlan'],
    }),
    markActionDismissed: builder.mutation<
      void,
      { actionID: string; careCircleID: string }
    >({
      query: ({ actionID, careCircleID }) => ({
        url: `/action-plan/care-circle/${careCircleID}/${actionID}/dismiss`,
        method: 'POST',
      }),
      invalidatesTags: ['CareCircles'],
    }),
    markActionCompleteForCareCircle: builder.mutation<
      void,
      { actionID: string; careCircleID: string }
    >({
      query: ({ actionID, careCircleID }) => ({
        url: `/action-plan/care-circle/${careCircleID}/${actionID}/complete`,
        method: 'POST',
      }),
      invalidatesTags: ['CareCircles'],
    }),
    getActionPlanForCareCircle: builder.query<ActionPlanItem[], string>({
      query: (careCircleID) => ({
        url: `/action-plan/care-circle/${careCircleID}`,
      }),
      providesTags: ['ActionPlan'],
    }),
  }),
});

export const {
  useGetAllActionPlanQuery,
  useUpdateActionPlanMutation,
  useGetAllActionPlanCategoryForCareCircleQuery,
  useGetAllActionPlanFeedbackQuery,
  useMarkActionFeedbackMutation,
  useGenerateActionPlanMutation,
  useMarkActionDismissedMutation,
  useMarkActionCompleteForCareCircleMutation,
  useGetActionPlanForCareCircleQuery,
} = actionPlanApi;

export default actionPlanApi;
